// @ts-nocheck
import { takeLatest, spawn, put } from 'redux-saga/effects';
import apiRequest, { apiSuccess } from 'utils/api';
import { appActions } from 'commons/reducer';
import { FEATURE_FLAGS, featureFlagsActions } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(FEATURE_FLAGS.GET_STATE_FROM_API, function* () {
    yield put(appActions.setLoader('get-feature-flags', true));
    const response = yield apiRequest('api/v1/featureFlags', { method: 'get' });
    yield put(apiSuccess(FEATURE_FLAGS.GET_STATE_FROM_API_SUCCESS, response));
    yield put(appActions.setLoader('get-feature-flags', false));
  });
}

function* editPermission() {
  yield takeLatest(FEATURE_FLAGS.EDIT_PERMISSION, function* (action) {
    const { permission_id, is_active } = action;
    yield put(appActions.setLoader(`edit-flag-${permission_id}`, true));
    const response = yield apiRequest('api/v1/featureFlags', {
      method: 'put',
      body: JSON.stringify({ permission_id, is_active }),
    });
    if (response && response.permission) {
        yield put(featureFlagsActions.editPermissionSuccess(response.permission));
        yield put(appActions.setSuccess(`Permiso ${is_active ? 'activado' : 'desactivado'} con éxito`));
    }
    yield put(appActions.setLoader(`edit-flag-${permission_id}`, false));
  });
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(editPermission);
}
